module.exports = __webpack_public_path__ + "img/color-pause-icon.9afcff9e.svg";